let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dHQJ1")).then(() => parcelRequire('1t3Es'));